// Configuração centralizada de URLs da API
const API_URL = process.env.REACT_APP_API_URL || 'https://candido-crm-api.onrender.com';

export default API_URL;

// Endpoints disponíveis
export const ENDPOINTS = {
  // Clients
  CLIENTS: `${API_URL}/api/clients`,
  CLIENT_BY_ID: (id) => `${API_URL}/api/clients/${id}`,
  
  // Prospects
  PROSPECTS: `${API_URL}/api/prospects`,
  PROSPECT_BY_ID: (id) => `${API_URL}/api/prospects/${id}`,
  
  // Indicadores
  INDICADORES: `${API_URL}/api/indicador`,
  INDICADOR_BY_ID: (id) => `${API_URL}/api/indicador/${id}`,
  
  // Usuarios
  USUARIOS: `${API_URL}/api/usuarios`,
  USUARIO_BY_ID: (id) => `${API_URL}/api/usuarios/${id}`,
  
  // Filiais
  FILIAIS: `${API_URL}/api/admin/filiais`,
  FILIAL_BY_ID: (id) => `${API_URL}/api/admin/filiais/${id}`,
  
  // Quotations
  QUOTATIONS: `${API_URL}/api/quotations`,
  QUOTATION_BY_ID: (id) => `${API_URL}/api/quotations/${id}`,
  
  // Products
  PRODUCTS: `${API_URL}/api/products`,
  
  // Notifications
  NOTIFICATIONS: `${API_URL}/api/notifications`,
  
  // Upload
  UPLOAD_ATTACHMENT: `${API_URL}/api/upload/upload-attachment`,
  UPLOAD_FILIAL_LOGO: `${API_URL}/api/upload/upload-filial-logo`,
  
  // Attachments
  ATTACHMENTS: (quotationId) => `${API_URL}/api/attachments/${quotationId}`,
};
